const ArrowUpRightIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M4.66667 11.3333L11.3333 4.66667M11.3333 4.66667H6M11.3333 4.66667V9.33333"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowUpRightIcon;
